import React, { ReactNode } from "react";
import {
  HeaderContainer,
  TitleWrap,
  TitleRow,
  PageTitle,
  MetaContainer,
  MetaItem,
  HeaderActions,
} from "./PageHeader.styled";

interface MetaItemData {
  text: string;
  key: string;
}

interface PageHeaderProps {
  title: string;
  badge?: ReactNode;
  metaItems?: MetaItemData[];
  actions?: ReactNode;
}

/**
 * Reusable page header component with title, metadata, and action buttons
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  badge,
  metaItems = [],
  actions,
}) => {
  return (
    <HeaderContainer>
      <TitleWrap>
        <TitleRow>
          <PageTitle>{title}</PageTitle>
          {badge}
        </TitleRow>

        {metaItems.length > 0 && (
          <MetaContainer>
            {metaItems.map((item, index) => (
              <React.Fragment key={item.key}>
                <MetaItem>{item.text}</MetaItem>
                {index < metaItems.length - 1 && <MetaItem>|</MetaItem>}
              </React.Fragment>
            ))}
          </MetaContainer>
        )}
      </TitleWrap>

      {actions && <HeaderActions>{actions}</HeaderActions>}
    </HeaderContainer>
  );
};

export default PageHeader;

